import { Button, Container, Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import './hero.scss'

const Hero = () => {
  const history = useHistory()

  return (
    <div className="hero">
      <div
        className="image"
        style={{
          backgroundImage: "url('images/homepage/hero/hero.jpg')",
        }}
      >
        <div className="overlay"> </div>

        <Container style={{ minHeight: 'unset', height: 600 }}>
          <div className="content">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={8} md={6} lg={4}>
                <div className="accent"></div>
                <h1>Welcome to MyQuality</h1>
                <p>
                  Welcome to MyQuality - your one-stop shop for your programming
                  and inspection needs. A quote is only a few clicks away.
                </p>
                <Button
                  className="btn-white"
                  onClick={() => history.push('/createaquote')}
                >
                  Start a quote
                </Button>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Hero
